import React, { Component } from 'react';
import { Col, Row, Button } from "react-bootstrap";
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import FieldGroup from "../../components/FieldGroup";
import { handleFieldChange } from "../../Utils";
import { API_URL } from "../../data/config";

class AdkReferrer extends Component {
    constructor() {
        super();

        this.state = {
            dateFrom: '',
            dateTo: '',
        };

        this.handleFieldChange = handleFieldChange.bind(this);
    }

    render() {
        const { isLoading, dateFrom, dateTo } = this.state;
        const url = `${API_URL}adkReferrer?dateFrom=${dateFrom}&dateTo=${dateTo}`

        return (
            <Container loading={isLoading}>
                <Heading title="ADK Referrer"/>

                <Row>
                    <Col lg={4}>
                        <FieldGroup
                            type="date"
                            name="dateFrom"
                            label="Date From:"
                            onChange={this.handleFieldChange}
                            value={this.state.dateFrom}
                        />
                    </Col>
                    <Col lg={4}>
                        <FieldGroup
                            type="date"
                            name="dateTo"
                            label="Date To:"
                            onChange={this.handleFieldChange}
                            value={this.state.dateTo}
                        />
                    </Col>
                </Row>
                <Button href={url} disabled={!(dateFrom && dateTo)}>Download</Button>
            </Container>
        );
    }
}

export default AdkReferrer;


// WEBPACK FOOTER //
// ./src/scenes/AdkReferrer/index.js